import { Grid } from '../../../../../Common/Grid'
import { Button, Typography } from "@fullscreendigital/carrefour-dex-fe";
import { TitleHeader } from '../../../../Common/TitleHeader'
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { makeCoreGetRequest } from "../../../../../../../utils/api";
import { formatErrorMessage } from '../../../../../../../utils/formatting';
import { useNotification } from '../../../../../../../hooks';
import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useReactToPrint } from 'react-to-print';

const RecordReturnStep6 = () => {
  const { showNotification } = useNotification();
  const location = useLocation();
  const navigate = useNavigate();
  const [headers, setHeaders] = useState([]);
  const [bodyArray, setBodyArray] = useState([]);

  const truckId = location.state;

  const fetchPdfCsv = async () => {
    return await makeCoreGetRequest(
      `/shop-reception-mobile/truck/hub/exit/centralized-notice/${truckId}`);
  };

  const {
    data: pdfCsv,
    isLoading: isLoadingPdf,
  } = useQuery('pdfCsv', fetchPdfCsv, {
    onError: error => {
      showNotification({
        message: `Error while fetching pdf. ${formatErrorMessage(error)}`,
        type: 'error'
      });
    }
  });

  useEffect(() => {
    if (pdfCsv) {
      const parsedHeaders = pdfCsv.split('\n')[0].split('|').map(header =>
        header.replace(/\./g, ' ').toUpperCase()
      );

      const parsedBody = pdfCsv
        .split('\n')
        .slice(1)
        .map(row => row.split('|'));

      setHeaders(parsedHeaders);
      setBodyArray(parsedBody);
    }
  }, [pdfCsv]);

  if (isLoadingPdf) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />;
  }

  return (
    <Grid
      gridContainerStyle={{ marginTop: '20px' }}
      maxWidth="xs"
      items={[
        <TitleHeader title="ÎNREGISTRARE RETUR" />,
        <Typography
          variant="medium"
          component="p"
          style={{ textAlign: "center" }}
        >
          A fost generat avizul!
        </Typography>,
        <div>
          {bodyArray.length > 0 && <TableToPrint headers={headers} bodyArray={bodyArray} />}
        </div>,
        <Button
          type="button"
          variant="contained"
          label="AM TERMINAT"
          onClick={() => navigate("/goodsReturnHub")}
          style={{ width: "100%" }}
        />
      ]}
      itemsPerRow={1}
    />
  );
};

const TableToPrint = ({ headers, bodyArray }) => {
  const tableRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
    documentTitle: 'Aviz_centralizator',
  });

  return (
    <div>
      <div ref={tableRef} style={{ overflowX: 'auto' }}>
        <table style={tableStyles}>
          <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={index} style={headerStyles}>
                {header}
              </th>
            ))}
          </tr>
          </thead>
          <tbody>
          {bodyArray.map((row, rowIndex) => (
            <tr key={rowIndex} style={rowIndex % 2 === 0 ? evenRowStyles : oddRowStyles}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex} style={cellStyles}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
          </tbody>
        </table>
      </div>
      <Button
        type="button"
        variant="contained"
        label="PRINTEAZǍ"
        onClick={handlePrint}
        style={{ width: "100%", marginTop: "15px" }}
      />
    </div>
  );
};

const tableStyles: React.CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  maxWidth: '100%',
  overflowX: 'auto',
  display: 'block',
};

const headerStyles: React.CSSProperties = {
  border: '1px solid black',
  padding: '4px',
  textAlign: 'left',
  backgroundColor: '#f2f2f2',
  fontWeight: 'bold',
};

const cellStyles: React.CSSProperties = {
  border: '1px solid black',
  padding: '4px',
  textAlign: 'left',
  whiteSpace: 'nowrap',
};

const evenRowStyles = {
  backgroundColor: '#f9f9f9',
};

const oddRowStyles = {
  backgroundColor: '#ffffff',
};

export default RecordReturnStep6;
